import { Observable } from "rxjs/Observable";

// Classes.
import { ViewData } from "./view-data";
import { RankingCategoryItem } from "../fetching/types/ranking-category.item";
import { DataContainer } from "../db/data-container";
import { ResponseData } from "../fetching/wa-response/wa-api-response";

// Providers.
import { LoggerService } from "../logger/logger-service";
import { DataFetchService } from "../wa-services/data-fetch-service";
import { DatabaseService } from "../wa-services/database-service";
import { FactoryService } from "../wa-services/factory-service";
import { WaHelperService } from "../wa-services/wa-helper-service";

// Interfaces.
import { LocatorInterface } from "../interfaces/locator.interface";
import { ViewDataConfigStruct } from "../interfaces/view-data.interface";

// Utility.
import { StringTools } from "../util/strings-tools";

export abstract class RankingCategoryListBaseVD extends ViewData<
  RankingCategoryItem
> {
  constructor(
    protected logger: LoggerService,
    protected fetchSrvc: DataFetchService,
    protected db: DatabaseService,
    protected factory: FactoryService,
    protected _helper: WaHelperService,
    protected _locator: LocatorInterface
  ) {
    super(logger, db, _locator);
  }

  public configureView() {
    let viewDataConf = new ViewDataConfigStruct();
    // Max age: 1 day.
    viewDataConf.maxAge = 86400;
    viewDataConf.expectedItems = "ALL";
    this.applyConfiguration(viewDataConf);
  }

  public preMapItemsDataContainerProcess(
    dataContainer: DataContainer<RankingCategoryItem>
  ): void {
    let payload = dataContainer.getPayload();

    if (payload) {
      //payload.sort((catA: RankingCategoryItem, catB: RankingCategoryItem) => this.sortRawRankingCategoriesFn(catA, catB));
      dataContainer.setPayload(payload);
    }
  }

  protected sortRawRankingCategoriesFn(catA: any, catB: any) {
    var nameA = this._helper.getCategoryInfoByCode(catA.Cat).name.toUpperCase();
    var nameB = this._helper.getCategoryInfoByCode(catB.Cat).name.toUpperCase();

    return StringTools.sortStringShortestRootPriorityFn(nameA, nameB);
  }

  public mapItem(rawItem: any): RankingCategoryItem {
    return this.factory.newRankingCategoryItem(rawItem);
  }

  public abstract updateData(): Observable<ResponseData>;
}
